module.exports = __webpack_public_path__ + "media/customizations/brighton/back-5fb626b489e459de10e08d3cf7ec9bb9.jpg";